export enum FieldDataType {
  NUMBER,
  DATE,
  TEXT,
  BOOLEAN,
}
